import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { UseFormReturn } from "react-hook-form";
import BadgeSelector from "./BadgeSelector";
import { DrinkingStatus, SmokerStatus, TattooStatus } from "@/generated-api";
import { useTranslation } from "@/hooks/useTranslation";
import vape from "@/assets/vape.png";
import tattoo from "@/assets/tattoo-device.png";
import cocktail from "@/assets/cocktail.png";

export default function SmokerTattoosDrinkingField({
  form,
  optional,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: UseFormReturn<any>;
  optional?: boolean;
}) {
  const t = useTranslation();

  return (
    <>
      <FormField
        control={form.control}
        name="smoker"
        render={({ field }) => (
          <FormItem className="grid grid-cols-1 sm:grid-cols-[1fr_2fr] items-center">
            <FormLabel
              htmlFor="smoker"
              className={`flex flex-row gap-2 items-center ${
                optional ? "text-gray-400" : ""
              }`}
            >
              <img src={vape} className="w-6 h-6" />
              {t.USER_FORM.LABELS.SMOKER}
            </FormLabel>
            <div>
              <FormControl>
                <BadgeSelector
                  selectedValues={field.value || []}
                  onChange={field.onChange}
                  enumObject={SmokerStatus}
                />
              </FormControl>
              <FormMessage className="mt-1" />
            </div>
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="tattoos"
        render={({ field }) => (
          <FormItem className="grid grid-cols-1 sm:grid-cols-[1fr_2fr] items-center">
            <FormLabel
              htmlFor="tattoos"
              className={`flex flex-row items-center gap-2 ${
                optional ? "text-gray-400" : ""
              }`}
            >
              <img src={tattoo} className="w-6 h-6" />
              {t.USER_FORM.LABELS.TATTOOS}
            </FormLabel>
            <div>
              <FormControl>
                <BadgeSelector
                  selectedValues={field.value || []}
                  onChange={field.onChange}
                  enumObject={TattooStatus}
                />
              </FormControl>
              <FormMessage className="mt-1" />
            </div>
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="drinking"
        render={({ field }) => (
          <FormItem className="grid grid-cols-1 sm:grid-cols-[1fr_2fr] items-center">
            <FormLabel
              htmlFor="drinking"
              className={`flex flex-row items-center gap-2 ${
                optional ? "text-gray-400" : ""
              }`}
            >
              <img src={cocktail} className="w-5 h-5" />
              {t.USER_FORM.LABELS.DRINKING}
            </FormLabel>
            <div>
              <FormControl>
                <BadgeSelector
                  selectedValues={field.value || []}
                  onChange={field.onChange}
                  enumObject={DrinkingStatus}
                />
              </FormControl>
              <FormMessage className="mt-1" />
            </div>
          </FormItem>
        )}
      />
    </>
  );
}
